import * as PIXI from 'pixi.js';
import AssetManager from '../Game/Base/AssetManager';
import GSOParasite from '../Game/Base/GSOParasite';
import Particle from './Particle';
import GSObjectArray from '../Game/Base/GSObjectArray';

export default class ParticlesOverlay extends GSOParasite {
    constructor(realParent, stepParent) {
        super(realParent, stepParent);

        this.pixiContainer = null;

        this.particles = new GSObjectArray(this, Particle);
    }

    spawnParticle(position, img = 'img.particle_coin', text = '+1') {
        const particle = new Particle(this, position, img, text);
        this._gsoCreateVisuals();
        this.particles.push(particle);
    }

    onCreateVisuals() {
        this.pixiContainer = new PIXI.Container();
        this.getAttachedStepParent().pixiContainerOverlayLayer.addChild(this.pixiContainer);
    }

    onUpdateVisuals() {}

    onDestroyVisuals() {
        this.pixiContainer.destroy();
    }

    onAttach() {}

    onDetach() {
        this.particles.destroy();
    }
}
